import type { ReactNode } from "react";

import { cn } from "../lib/utils";

interface StatCardProps {
  label: string;
  value: ReactNode;
  hint?: string;
  trend?: ReactNode;
  icon?: ReactNode;
  muted?: boolean;
  className?: string;
}

export function StatCard({
  label,
  value,
  hint,
  trend,
  icon,
  muted = false,
  className,
}: StatCardProps) {
  return (
    <div
      className={cn(
        "rounded-lg border border-border bg-card p-4 shadow-sm transition-colors hover:border-primary/40",
        muted && "opacity-70",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          {label}
        </p>
        {icon ? <span className="text-primary">{icon}</span> : null}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <span
          className={cn(
            "text-2xl font-semibold tabular-nums tracking-tight",
            muted ? "text-neutral-inactive" : "text-foreground",
          )}
        >
          {value}
        </span>
        {trend}
      </div>
      {hint ? <p className="mt-2 text-xs leading-relaxed text-muted-foreground">{hint}</p> : null}
    </div>
  );
}
